var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finishExamAuth"},[_c('img',{staticClass:"applysuc_img",attrs:{"src":require("../assets/images/ic-xfcg.png")}}),_c('p',{staticClass:"tips"},[_vm._v("您已完成考试提报")]),_c('div',{staticClass:"view_btn",on:{"click":_vm.toViewAuthDetail}},[_vm._v("查看考试认证信息")])])
}
var staticRenderFns = []

export { render, staticRenderFns }